import React, { useEffect, useState } from 'react';
import "../../../../assets/css/cms/scheduler.css";
import { IoFilter } from "react-icons/io5";
import ToggleView from "./toggleView.js";
import HeaderTab from "./headerTabs.js";
import FilterModal from './filterBlock.js';
import { useDispatch,useSelector } from "react-redux";
import {getContentTypeFilter,getScheduledQueueList, getPublishedList} from "../../../../../store/actions/cms/scheduler.js";

export const ContentScheduler = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [queueLength, setQueueLength] = useState(0);
  const [queueCurrentPage, setQueueCurrentPage] = useState(0);
  const [publishedLength, setPublishedLength] = useState('0');
  const [publishedCurrentPage, setPublishedCurrentPage] = useState('0');

  const { queueDraftsData ,publishedListData} = useSelector((state) => {
        return (state?.contentSchedularReducer);
    });

  const handleFilter = () => {
    setShowModal(true);
  }

  useEffect(() => {
    dispatch(getScheduledQueueList({page:1,page_size:12}))
    dispatch(getPublishedList({page:1,page_size:12}))
    dispatch(getContentTypeFilter({filter_type:"content_type"}));
    return () => {
      localStorage.removeItem("activeContentTab", "");
    };
  }, []);  

  useEffect(() => {
    if(queueDraftsData?.results?.length>0) setQueueLength(queueDraftsData?.results?.length)
    if(publishedListData?.results?.length>0) setPublishedLength(publishedListData?.results?.length)

  }, [queueDraftsData,publishedListData])

  const handleViewChange = (view) => {
    // console.log("Selected view:", view);
  };

  
  return (
    <>
     <div className='content_scheduler'>
        <div className='content_head'>
          <h3>Content Scheduler</h3>
          <div className='content_menu'>
            <button className='content_filter' onClick={handleFilter}>
                <IoFilter className='content_filter_icon' />
                  Filter
            </button>
            <FilterModal 
              currentPage={currentPage} 
              setCurrentPage={setCurrentPage} 
              queueCurrentPage={queueCurrentPage}
              setQueueCurrentPage={setQueueCurrentPage}
              publishedCurrentPage={publishedCurrentPage}
              setPublishedCurrentPage={setPublishedCurrentPage}
              show={showModal} onHide={() => setShowModal(false)} 
            />
            <div className='content_toggle_menu'>
              <ToggleView onChange={handleViewChange} />
            </div>
          </div>
        </div>
        <div className='content_tabs'>
          <HeaderTab
            currentPage={currentPage} 
            setCurrentPage={setCurrentPage} 
            queueLength={queueLength} 
            setQueueLength={setQueueLength}
            queueCurrentPage={queueCurrentPage}
            setQueueCurrentPage={setQueueCurrentPage}
            publishedCurrentPage={publishedCurrentPage}
            setPublishedCurrentPage={setPublishedCurrentPage}
            publishedLength={publishedLength}
            setPublishedLength={setPublishedLength}
          />
        </div>
     </div>
    </>
  )
}